module.exports = __webpack_public_path__ + "img/3-5.8878895.jpg";